export const _ROUTERS = {
  home: "/",
  view: "/view",
};
